import { defineMessages, FormattedMessage } from 'react-intl';

export const myAddresses = defineMessages({
  unsupportedCountry: {
    defaultMessage: 'unsupported country',
    id: 'myAddresses.unsupportedCountry',
  },
  nameMissing: {
    defaultMessage: 'First name and last name is required',
    id: 'myAddresses.nameMissing',
  },
});

export const addressesHistory = (
  <FormattedMessage
    defaultMessage='My shipping & billing Addresses'
    id='addresses.addressesHistory'
  />
);

export const primaryShippingAddress = (
  <FormattedMessage
    defaultMessage='Primary shipping address'
    id='addresses.primaryShippingAddress'
  />
);

export const primaryBillingAddress = (
  <FormattedMessage
    defaultMessage='Primary billing address'
    id='addresses.primaryShippingAddress'
  />
);

export const addNewAddress = (
  <FormattedMessage
    defaultMessage='Add a new address'
    id='addresses.addNewAddress'
  />
);

export const editAddress = (
  <FormattedMessage defaultMessage='Edit address' id='addresses.editAddress' />
);

export const deleteAddress = (
  <FormattedMessage
    defaultMessage='Delete this address'
    id='addresses.deleteAddress'
  />
);

export const deleteConfirm = (
  <FormattedMessage
    defaultMessage='Do you confirm you want to delete this address?'
    id='addresses.deleteConfirm'
  />
);

export const EmptyAddressesHistory = (
  <FormattedMessage
    defaultMessage='You do not have addresses history yet,{br}Add an address for easy checkout.'
    id='addresses.emptyAddressesHistory'
    values={{
      br: <br />,
    }}
  />
);

export const UnauthorizedShippingCountry = (
  <FormattedMessage
    defaultMessage='Unauthorized shipping to country, still want to save?'
    id='addresses.unauthorizedShippingCountry'
  />
);

export const UnsupportedBillingCountry = (
  <FormattedMessage
    defaultMessage='Unsupported billing country, still want to save?'
    id='addresses.unsupportedBillingCountry'
  />
);
